import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingState, ObservableState } from 'src/app/core/constants/observable-state.interface';

import { Product } from 'src/app/products/models/product.model';
import { CardLoaderComponent } from "src/app/components/card-loader/card-loader.component";
import { RelatedProductsCarouselComponent } from "../related-products-carousel/related-products-carousel.component";
import { ServerErrorComponent } from "src/app/components/server-error/server-error.component";

/**
 * @todo Delete this component
 */
@Component({
  standalone: true,
  selector: 'webstore-related-products-wrapper',
  templateUrl: './related-products-wrapper.component.html',
  styleUrls: ['./related-products-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, CardLoaderComponent, RelatedProductsCarouselComponent, ServerErrorComponent]
})
export class RelatedProductsWrapperComponent {

  readonly heading = input<string>('');
  readonly products = input<ObservableState<Product[]>>({ loadingState: LoadingState.Loading, response: [] });

  LoadingState = LoadingState;

}

